import { useEffect, useRef, useState } from "react";
import { Developer } from "../../../Customers/types";
import { ApiClient } from "../../../../utils/axiosConfig";

export const useCustomers = () => {
  const [developers, setDevelopers] = useState<Developer[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [item, setItem] = useState<number>(0);
  const [itemsInView, setItemsInView] = useState<number>(3);
  const developersContainerRef = useRef<HTMLDivElement>(null);

  const { get } = ApiClient();

  const getDevelopers = async () => {
    setLoading(true);
    try {
      const response = await get<Developer[], undefined>(
        "/api/dona/v1/public/customers/developers/all",
      );
      setDevelopers(response.data);
    } catch (error) {
      console.error(error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleNext = () => {
    if (item < developers.length - itemsInView) {
      setItem(item + 1);
    }
  };

  const handlePrev = () => {
    if (item > 0) {
      setItem(item - 1);
    }
  };

  useEffect(() => {
    if (developersContainerRef.current) {
      const child = developersContainerRef.current.children[0];
      if (!child) return;

      const numberOfItemsInView = Math.floor(
        developersContainerRef.current.clientWidth / child.clientWidth,
      );

      setItemsInView(numberOfItemsInView);

      const childWidth =
        child.clientWidth + parseInt(getComputedStyle(child).marginRight) + 2;
      developersContainerRef.current.scrollTo({
        left: item * childWidth,
        behavior: "smooth",
      });
    }
  }, [item, developersContainerRef, developers]);

  return {
    getDevelopers,
    developers,
    loading,
    error,
    item,
    handleNext,
    handlePrev,
    developersContainerRef,
  };
};
